import { memo } from 'react';
import { content } from './content';
import { Text, Icon, RoundedCard } from '../../components';
import bgImage2 from "../../assets/images/bg-image2.png";
import bgImage3 from "../../assets/images/bg-image3.png";
import bgImage4 from "../../assets/images/bg-image4.png";
import "./OnlineBusinessConsulting.scss";

function MemoComponent({ id }: { id: string }) {
  return (
    <section id={id} className="online-business-consulting">
      <div className="section-content">
        <Text variant="title2" weight={700}>{content.title}</Text>

        <div>
          <Text variant="content3" color="tertiary" className="mb-20" align="center">
            {content.paragraph1}
          </Text>
          <Text variant="content3" color="tertiary" className="mb-20" align="center">
            {content.paragraph2}
          </Text>
          <Text variant="content3" color="tertiary" align="center">
            {content.paragraph3}
          </Text>
        </div>

        <RoundedCard className="display-flex flex-wrap gap-20">
          <div className="left-side">
            <Text variant="subtitle1" weight={700} className="mb-30">
              {content.productCard.title}
            </Text>
            <Text variant="content3" color="tertiary" className="mb-20">
              {content.productCard.paragraph1}
            </Text>
            <Text variant="content3" color="tertiary">
              {content.productCard.paragraph2}
            </Text>
          </div>

          <div className="right-side display-flex-column justify-center gap-20">
            {content.productCard.items.map((item, index) => (
              <div key={index} className="display-flex align-items-center gap-30">
                <Icon className="icon-circled-check" size={24} color="tertiary"/>
                <Text variant="content3">
                  {item.label}
                </Text>
              </div>
            ))}
          </div>
        </RoundedCard>

        <RoundedCard className="display-flex flex-wrap gap-20">
          <div className="left-side">
            <Text variant="subtitle1" weight={700} className="mb-30">
              {content.graphicCard.title}
            </Text>
            <Text variant="content3" color="tertiary" className="mb-20">
              {content.graphicCard.paragraph1}
            </Text>
            <Text variant="content3" color="tertiary">
              {content.graphicCard.paragraph2}
            </Text>
          </div>

          <div className="right-side display-flex-column justify-center gap-20">
            {content.graphicCard.items.map((item, index) => (
              <div key={index} className="display-flex align-items-center gap-30">
                <Icon className="icon-circled-check" size={24} color="tertiary"/>
                <Text variant="content3">
                  {item.label}
                </Text>
              </div>
            ))}
          </div>
        </RoundedCard>
      </div>

      <img src={bgImage2} alt="background decorators" className="bg-image top"/>
      <img src={bgImage3} alt="background decorators" className="bg-image bottom-left"/>
      <img src={bgImage4} alt="background decorators" className="bg-image bottom-right"/>
    </section>
  )
};

export const OnlineBusinessConsulting = memo(MemoComponent);